import { useCollection } from "@/composables/useFirestore";
import { db } from "@/firebase";
import type {
  TrackedCategoryDirection,
  TrackedCategoryGroup,
} from "@aircap/common/trackedCategory";
import { collection } from "firebase/firestore";
import { computed, type Ref } from "vue";

export type TrackedCategoryGroupWithId = TrackedCategoryGroup & { id: string };

export function useTrackedCategoryGroups(
  accountId: Ref<string>,
  direction: TrackedCategoryDirection,
) {
  const groupsSource = computed(() =>
    collection<TrackedCategoryGroup>(db, `accounts/${accountId.value}/trackedCategoryGroups`),
  );

  const { data: groupsRaw, pending: loading } = useCollection<TrackedCategoryGroup>(groupsSource);

  const groups = computed<TrackedCategoryGroupWithId[]>(() => {
    if (!groupsRaw.value) return [];

    return groupsRaw.value
      .filter((group) => !group.deletedAt && group.direction === direction)
      .map((group) => ({
        id: group.id,
        name: group.name,
        direction: group.direction,
        order: group.order,
        createdAt: group.createdAt,
        updatedAt: group.updatedAt,
      }))
      .sort((a, b) => {
        const ao = a.order ?? Infinity;
        const bo = b.order ?? Infinity;
        if (ao !== bo) return ao - bo;
        const at = a.createdAt?.toMillis?.() ?? 0;
        const bt = b.createdAt?.toMillis?.() ?? 0;
        return at - bt;
      });
  });

  return {
    groups,
    groupsRaw,
    loading,
  };
}
